(function () {
  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (error) {}
    return true;
  }

  function publish(eventName, eventData) {
    if (!analyticsAllowed()) return;
    var payload = Object.assign({ path: window.location.pathname }, eventData || {});

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var result = window.Shopify.analytics.publish(eventName, payload);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (error) {}

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName.replace(/:/g, '_') }, payload));
    }
  }

  var builderStarted = false;
  window.AurexAnalytics = { publish: publish };
  document.documentElement.setAttribute('data-aurex-tracking', 'ready');

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (href.indexOf('tel:') === 0) publish('aurex:phone_clicked', { location: 'website' });
      else if (href.indexOf('mailto:') === 0) publish('aurex:email_clicked', { location: 'website' });
      else if (href.indexOf('/pages/free-measure-quote') !== -1 || href === '#shower-quote') {
        publish('aurex:quote_cta_clicked', { destination: href });
      }
    }

    var addButton = event.target.closest('#AddConfiguredProduct');
    if (addButton && !addButton.disabled) {
      publish('aurex:wardrobe_add_to_cart_clicked', { product: window.location.pathname });
    }
  });

  function recordBuilderStart(event) {
    if (builderStarted || !event.target.closest('#AurexProductForm')) return;
    builderStarted = true;
    publish('aurex:wardrobe_builder_started', { product: window.location.pathname });
  }

  document.addEventListener('input', recordBuilderStart);
  document.addEventListener('change', recordBuilderStart);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-aurex-protected-form]');
    if (!form || event.defaultPrevented) return;
    publish('aurex:lead_submitted', {
      form_id: form.id || form.getAttribute('data-aurex-form-kind') || 'contact'
    });
  });
})();
